var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWalletHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.125C7.7625 28.125 1.875 22.2375 1.875 15C1.875 7.7625 7.7625 1.875 15 1.875C22.2375 1.875 28.125 7.7625 28.125 15C28.125 22.2375 22.2375 28.125 15 28.125ZM15 3.75C8.79375 3.75 3.75 8.79375 3.75 15C3.75 21.2062 8.79375 26.25 15 26.25C21.2062 26.25 26.25 21.2062 26.25 15C26.25 8.79375 21.2062 3.75 15 3.75Z",
    fill: "#1e88e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.5625C14.475 21.5625 14.0625 21.15 14.0625 20.625V9.375C14.0625 8.85 14.475 8.4375 15 8.4375C15.525 8.4375 15.9375 8.85 15.9375 9.375V20.625C15.9375 21.15 15.525 21.5625 15 21.5625Z",
    fill: "#1e88e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 15.9375H9.375C8.85 15.9375 8.4375 15.525 8.4375 15C8.4375 14.475 8.85 14.0625 9.375 14.0625H20.625C21.15 14.0625 21.5625 14.475 21.5625 15C21.5625 15.525 21.15 15.9375 20.625 15.9375Z",
    fill: "#1e88e5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWalletHover);
export default __webpack_public_path__ + "static/media/add_wallet_hover.e8ddd8acbdca6ebbad1237acff1f2f8d.svg";
export { ForwardRef as ReactComponent };